import { GetPipelineStageProjectsInput } from '@/gql/graphql';
import AccountUserAvatarSelector from '@/ui/components/accountUserAvatarSelector/AccountUserAvatarSelector';
import { useMemo } from 'react';

type Props = {
  disabled?: boolean;
  minVisible?: number;
  preferredUserIds?: string[];
  input?: GetPipelineStageProjectsInput;
  onChangeInput?: React.Dispatch<
    React.SetStateAction<GetPipelineStageProjectsInput | undefined>
  >;
};

function PipelineUserSelection(props: Props) {
  const { disabled, minVisible, preferredUserIds, input, onChangeInput } =
    props;

  const selectedUserIds = useMemo(
    () => (input?.assignedTo ?? []).filter((id): id is string => Boolean(id)),
    [input?.assignedTo]
  );

  const handleChange = (next: string[]) => {
    onChangeInput?.((prev) => ({ ...prev, assignedTo: next }));
  };

  return (
    <AccountUserAvatarSelector
      selectedUserIds={selectedUserIds}
      onChange={handleChange}
      disabled={disabled}
      minVisible={minVisible}
      preferredUserIds={preferredUserIds}
    />
  );
}

export default PipelineUserSelection;
